var map = {
	"./abkhazia.webp": 1923,
	"./afganistan.webp": 1924,
	"./albania.webp": 1925,
	"./algeria.webp": 1926,
	"./american_samoa.webp": 1927,
	"./andorra.webp": 1928,
	"./angola.webp": 1929,
	"./anguilla.webp": 1930,
	"./antigua_and_barbuda.webp": 1931,
	"./argentina.webp": 1932,
	"./armenia.webp": 1933,
	"./aruba.webp": 1934,
	"./australia.webp": 1935,
	"./austria.webp": 1936,
	"./azad_kashmir.webp": 1937,
	"./azerbaijan.webp": 1938,
	"./bahamas.webp": 1939,
	"./bahrain.webp": 1940,
	"./bangladesh.webp": 1941,
	"./barbados.webp": 1942,
	"./belarus.webp": 1943,
	"./belgium.webp": 1944,
	"./belize.webp": 1945,
	"./benin.webp": 1946,
	"./bermuda.webp": 1947,
	"./bhutan.webp": 1948,
	"./bolivia.webp": 1949,
	"./bosnia_and_herzegovina.webp": 1950,
	"./botswana.webp": 1951,
	"./brazil.webp": 1952,
	"./brunei.webp": 1953,
	"./bulgaria.webp": 1954,
	"./burkina_faso.webp": 1955,
	"./burundi.webp": 1956,
	"./cambodia.webp": 1957,
	"./cameroon.webp": 1958,
	"./canada.webp": 1959,
	"./cape_verde.webp": 1960,
	"./cayman_islands.webp": 1961,
	"./central_african_republic.webp": 1962,
	"./chad.webp": 1963,
	"./chile.webp": 1964,
	"./china.webp": 1965,
	"./colombia.webp": 1966,
	"./comoros.webp": 1967,
	"./congo.webp": 1968,
	"./cook_island.webp": 1969,
	"./costa_rica.webp": 1970,
	"./croatia.webp": 1971,
	"./cuba.webp": 1972,
	"./cyprus.webp": 1973,
	"./czech_republick.webp": 1974,
	"./democratic_republic_of_the_congo.webp": 1975,
	"./denmark.webp": 1976,
	"./djibouti.webp": 1977,
	"./dominica.webp": 1978,
	"./dominican_republic.webp": 1979,
	"./donetsk_people_s_republic.webp": 1980,
	"./east_timor.webp": 1981,
	"./ecuador.webp": 1982,
	"./egypt.webp": 1983,
	"./el_salvador.webp": 1984,
	"./equatorial_guinea.webp": 1985,
	"./eritrea.webp": 1986,
	"./estonia.webp": 1987,
	"./eswatini.webp": 1988,
	"./ethiopia.webp": 1989,
	"./falkland_islands.webp": 1990,
	"./federated_states_of_micronesia.webp": 1991,
	"./fiji.webp": 1992,
	"./finland.webp": 1993,
	"./france.webp": 1994,
	"./french_guiana.webp": 1995,
	"./gabon.webp": 1996,
	"./gambia.webp": 1997,
	"./georgia.webp": 1998,
	"./germany.webp": 1999,
	"./ghana.webp": 2000,
	"./gibraltar.webp": 2001,
	"./globe.webp": 2002,
	"./greece.webp": 2003,
	"./greenland.webp": 2004,
	"./grenada.webp": 2005,
	"./guadeloupe.webp": 2006,
	"./guam.webp": 2007,
	"./guatemala.webp": 2008,
	"./guernsey.webp": 2009,
	"./guinea.webp": 2010,
	"./guinea_bissau.webp": 2011,
	"./guyana.webp": 2012,
	"./haiti.webp": 2013,
	"./honduras.webp": 2014,
	"./hong_kong.webp": 2015,
	"./hungary.webp": 2016,
	"./iceland.webp": 2017,
	"./india.webp": 2018,
	"./indonesia.webp": 2019,
	"./iran.webp": 2020,
	"./iraq.webp": 2021,
	"./ireland.webp": 2022,
	"./isle_of_man.webp": 2023,
	"./israel.webp": 2024,
	"./italy.webp": 2025,
	"./ivory_coast.webp": 2026,
	"./jamaica.webp": 2027,
	"./japan.webp": 2028,
	"./jersey.webp": 2029,
	"./jordan.webp": 2030,
	"./kazakhstan.webp": 2031,
	"./kenya.webp": 2032,
	"./kirgyzstan.webp": 2033,
	"./kiribati.webp": 2034,
	"./kosovo.webp": 2035,
	"./kuwait.webp": 2036,
	"./laos.webp": 2037,
	"./latvia.webp": 2038,
	"./lebanon.webp": 2039,
	"./lesotho.webp": 2040,
	"./liberia.webp": 2041,
	"./libyan_arab_jamahiriya.webp": 2042,
	"./liechtenstein.webp": 2043,
	"./lihansk_people_s_republic.webp": 2044,
	"./lithuania.webp": 2045,
	"./luxembourg.webp": 2046,
	"./macao.webp": 2047,
	"./macedonia.webp": 2048,
	"./madagascar.webp": 2049,
	"./malawi.webp": 2050,
	"./malaysia.webp": 2051,
	"./maldives.webp": 2052,
	"./mali.webp": 2053,
	"./malta.webp": 2054,
	"./marshall_islands.webp": 2055,
	"./martinique.webp": 2056,
	"./mauritania.webp": 2057,
	"./mauritius.webp": 2058,
	"./mayotte.webp": 2059,
	"./mexico.webp": 2060,
	"./moldova.webp": 2061,
	"./monaco.webp": 2062,
	"./mongolia.webp": 2063,
	"./montenegro.webp": 2064,
	"./montserrat.webp": 2065,
	"./morocco.webp": 2066,
	"./mozambique.webp": 2067,
	"./myanmar.webp": 2068,
	"./namibia.webp": 2069,
	"./nauru.webp": 2070,
	"./nepal.webp": 2071,
	"./netherlands.webp": 2072,
	"./new_caledonia.webp": 2073,
	"./new_zealand.webp": 2074,
	"./nicaragua.webp": 2075,
	"./niger.webp": 2076,
	"./nigeria.webp": 2077,
	"./niue.webp": 2078,
	"./norfolk_island.webp": 2079,
	"./north_korea.webp": 2080,
	"./norway.webp": 2081,
	"./notrhen_cyprus.webp": 2082,
	"./oman.webp": 2083,
	"./pakistan.webp": 2084,
	"./palau.webp": 2085,
	"./panama.webp": 2086,
	"./papua_new_guinea.webp": 2087,
	"./paraguay.webp": 2088,
	"./peru.webp": 2089,
	"./philippines.webp": 2090,
	"./poland.webp": 2091,
	"./portugal.webp": 2092,
	"./pridnestrovian_moldovian_republic.webp": 2093,
	"./puerto_rico.webp": 2094,
	"./qatar.webp": 2095,
	"./republick_of_artsakh.webp": 2096,
	"./romania.webp": 2097,
	"./russia.webp": 2098,
	"./rwanda.webp": 2099,
	"./saint_barthelemy.webp": 2100,
	"./saint_kitts_and_nevis.webp": 2101,
	"./saint_lucia.webp": 2102,
	"./saint_martin.webp": 2103,
	"./saint_vincent_and_the_grenadines.webp": 2104,
	"./samoa.webp": 2105,
	"./san_marino.webp": 2106,
	"./sao_tome_and_principe.webp": 2107,
	"./saudi_arabia.webp": 2108,
	"./senegal.webp": 2109,
	"./serbia.webp": 2110,
	"./seychelles.webp": 2111,
	"./sierra_leone.webp": 2112,
	"./singapore.webp": 2113,
	"./slovakia.webp": 2114,
	"./slovenia.webp": 2115,
	"./solomon_islands.webp": 2116,
	"./somalia.webp": 2117,
	"./somaliland.webp": 2118,
	"./south_africa.webp": 2119,
	"./south_korea.webp": 2120,
	"./south_ossetia.webp": 2121,
	"./south_sudan.webp": 2122,
	"./spain.webp": 2123,
	"./sri_lanka.webp": 2124,
	"./state_of_palestine.webp": 2125,
	"./sudan.webp": 2126,
	"./suriname.webp": 2127,
	"./sweden.webp": 2128,
	"./switzerland.webp": 2129,
	"./syrian_arab_republic.webp": 2130,
	"./taiwan.webp": 2131,
	"./tajikistan.webp": 2132,
	"./tanisia.webp": 2133,
	"./tanzania.webp": 2134,
	"./thailand.webp": 2135,
	"./togo.webp": 2136,
	"./tonga.webp": 2137,
	"./trinidad_and_tobago.webp": 2138,
	"./tunisia.webp": 2139,
	"./turkey.webp": 2140,
	"./turkmenistan.webp": 2141,
	"./tuvalu.webp": 2142,
	"./uganda.webp": 2143,
	"./ukraine.webp": 2144,
	"./united_arab_emirates.webp": 2145,
	"./united_kingdom.webp": 2146,
	"./uruguay.webp": 2147,
	"./usa.webp": 2148,
	"./uzbekistan.webp": 2149,
	"./vanuatu.webp": 2150,
	"./vatican.webp": 2151,
	"./venezuela.webp": 2152,
	"./vietnam.webp": 2153,
	"./virgin_islands_br.webp": 2154,
	"./virgin_islands_us.webp": 2155,
	"./wallis_and_futuna.webp": 2156,
	"./western_sahara.webp": 2157,
	"./yemen.webp": 2158,
	"./zaire.webp": 2159,
	"./zambia.webp": 2160,
	"./zimbabwe.webp": 2161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1462;